import React from "react";
import Carousel from "../../components/general/carousel";
import Modal from "../../components/general/modal";
import close_icon from "../../assets/images/register/step1/cross.png";
import themeColor from "../../styles/themeColor";
import "moment/locale/zh-hk";
import "moment/locale/en-gb";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isValidUrl } from "../../helpers/generalHelper";
import LangSwitch from "../../components/general/langSwitch";

const NewsModal = (props) => {
  const { show, handleClose } = props;
  const { i18n } = useTranslation();
  const announcements = useSelector((state) => state.announcement);

  const visibleAnnouncements = [...announcements.list]
    .sort((a, b) => (a.priority || Infinity) - (b.priority || Infinity))
    .filter((announcement) => announcement.status === "publish");

  return (
    <Modal show={show} onHide={handleClose}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: themeColor.lightOptionColor,
          borderRadius: 15,
          boxShadow: `0px 3px 6px ${themeColor.shadowGrey}`,
          border: `1px solid ${themeColor.borderColor}`,
          width: "95vw",
          alignSelf: "center",
          padding: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <LangSwitch />
          <div>
            <button
              type="button"
              style={{
                background: "transparent",
                border: "none",
                outline: "none",
              }}
              onClick={() => {
                handleClose();
              }}
            >
              <img
                src={close_icon}
                alt="close"
                style={{
                  objectFit: "contain",
                  width: 30,
                  float: "right",
                  filter: "brightness(0)",
                }}
              />
            </button>
          </div>
        </div>
        <Carousel
          indicators={visibleAnnouncements.length > 1}
          style={{
            width: "100%",
            alignSelf: "flex-start",
          }}
        >
          {visibleAnnouncements.map((announcement) => {
            // eslint-disable-next-line no-underscore-dangle
            const announcementKey = announcement._id;
            const image =
              (i18n.language === "zh"
                ? announcement.image_zh
                : announcement.image) || {};
            const url =
              i18n.language === "zh" ? announcement.url_zh : announcement.url;
            const hasUrl = isValidUrl(url);
            const subject =
              i18n.language === "zh"
                ? announcement.subject_zh
                : announcement.subject;
            const content =
              i18n.language === "zh"
                ? announcement.content_zh
                : announcement.content;

            if (isValidUrl(image.fileUrl)) {
              return (
                <Carousel.Item
                  key={announcementKey}
                  style={{ overflowY: "auto", maxHeight: "calc(95vh - 80px)" }}
                >
                  {hasUrl ? (
                    <a href={url} target="_blank" rel="noreferrer">
                      <img
                        src={image.fileUrl}
                        alt={subject}
                        style={{
                          display: "block",
                          margin: "0 auto",
                          width: "100%",
                          height: "auto",
                          maxWidth: "max-content",
                        }}
                      />
                    </a>
                  ) : (
                    <img
                      src={image.fileUrl}
                      alt={subject}
                      style={{
                        display: "block",
                        margin: "0 auto",
                        width: "100%",
                        height: "auto",
                        maxWidth: "max-content",
                      }}
                    />
                  )}
                  {(url || subject || content) && (
                    <Carousel.Caption
                      style={{
                        backgroundColor: themeColor.backgroundColor,
                        opacity: 0.95,
                        padding: 20,
                      }}
                    >
                      {hasUrl ? (
                        <a href={url} target="_blank" rel="noreferrer">
                          <h4 style={{ color: themeColor.textColor }}>
                            {subject}
                          </h4>
                        </a>
                      ) : (
                        <h4 style={{ color: themeColor.textColor }}>
                          {subject}
                        </h4>
                      )}
                      <div
                        style={{
                          color: themeColor.textColor,
                          overflowY: "scroll",
                          maxHeight: "10vh",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: content,
                        }}
                      />
                    </Carousel.Caption>
                  )}
                </Carousel.Item>
              );
            }
            return (
              <Carousel.Item
                key={announcementKey}
                style={{ overflowY: "auto", maxHeight: "calc(95vh - 80px)" }}
              >
                <div
                  style={{
                    backgroundColor: themeColor.backgroundColor,
                    opacity: 0.8,
                    minHeight: "30vh",
                    width: "100%",
                    padding: 20,
                  }}
                >
                  {hasUrl ? (
                    <a href={url} target="_blank" rel="noreferrer">
                      <h4 style={{ color: themeColor.textColor }}>{subject}</h4>
                    </a>
                  ) : (
                    <h4 style={{ color: themeColor.textColor }}>{subject}</h4>
                  )}
                  <div
                    style={{
                      color: themeColor.textColor,
                      overflowY: "scroll",
                      maxHeight: "80vh",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
    </Modal>
  );
};

export default NewsModal;
